import React, { useEffect, useState } from "react";
import "./logs.scss";

import { Box, Stack } from "@mui/material";

import LogsTable from "./components/logsTable/LogsTable";
import DateFilter from "../../components/dateFilter/DateFilter";

import { getLogsWS } from "./logsApi";
import { gestioneSnackbar } from "../../utils/common";

const Logs = () => {
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [data, setData] = useState([]);

  const refreshContent = ({ start, end }) => {
    getLogsWS({ start, end })
      .then((res) => {
        setData(res);
      })
      .catch((err) => gestioneSnackbar(true, err, "error"));
  };

  useEffect(() => {
    refreshContent({ start, end });
  }, []);

  console.log(data);
  return (
    <Box>
      <Stack gap={2}>
        <DateFilter
          startDateTime={start}
          setStartDateTime={setStart}
          endDateTime={end}
          setEndDateTime={setEnd}
          APICall={() => refreshContent({ start, end })}
        />
        <LogsTable data={data} />
      </Stack>
    </Box>
  );
};

export default Logs;
